<div class="form-field__label form-field__label--external">
  {{ field?.label | translateInline }}
</div>

<div class="compliments">
  @for (c of compliments$ | async; track c.key) {
    <fmnts-compliment
      [label]="c.label | translateInline"
      [image]="c.image"
      [state]="c.checked ? 'default' : 'disabled'"
      [size]="c.checked ? 'lg' : 'md'"
      labelPosition="bottom"
    ></fmnts-compliment>
  }
</div>
